// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hZom","questions":"styles_questions__2gHu3","footer":"styles_footer__3mCc5"};